// Translation
import { useTrans } from "@/i18n"

// API
import {
	type KycVerificationDocumentType,
	RiskKycVerificationDocumentDocumentTypeChoices,
} from "@/api/graphql"

// DateTime
import { DateTime } from "@/lib/dates"

// Table components
import {
	Table,
	TableBody,
	TableDataCell,
	TableHead,
	TableHeading,
	TableRowCell,
} from "@/components/table-controls/TableItems"

/**
 * DocumentsTable
 * @param documents
 * @returns
 */
export const DocumentsTable = ({
	documents,
}: {
	documents: KycVerificationDocumentType[]
}) => {
	const t = useTrans("investor")

	// Helper function to get document type display name
	const getDocumentTypeDisplayName = (documentType: string) => {
		const typeMap: Record<string, string> = {
			[RiskKycVerificationDocumentDocumentTypeChoices.ArticlesOfAssociation]:
				"Statuten",
			[RiskKycVerificationDocumentDocumentTypeChoices.BankCard]:
				"Bankpas",
			[RiskKycVerificationDocumentDocumentTypeChoices.BankStatement]:
				"Bankafschrift",
			[RiskKycVerificationDocumentDocumentTypeChoices.Contract]:
				"Contract",
			[RiskKycVerificationDocumentDocumentTypeChoices.CreditReport]:
				"Kredietrapport",
			[RiskKycVerificationDocumentDocumentTypeChoices.DrivingLicense]:
				"Rijbewijs",
			[RiskKycVerificationDocumentDocumentTypeChoices.EmploymentCertificate]:
				"Werkgeversverklaring",
			[RiskKycVerificationDocumentDocumentTypeChoices.NationalIdNumber]:
				"Identiteitskaart",
			[RiskKycVerificationDocumentDocumentTypeChoices.NationalInsuranceNumber]:
				"Burgerservicenummer (BSN)",
			[RiskKycVerificationDocumentDocumentTypeChoices.Other]: "Anders",
			[RiskKycVerificationDocumentDocumentTypeChoices.Passport]:
				"Paspoort",
			[RiskKycVerificationDocumentDocumentTypeChoices.PollingCard]:
				"Stempas",
			[RiskKycVerificationDocumentDocumentTypeChoices.ResidencePermit]:
				"Verblijfsvergunning",
			[RiskKycVerificationDocumentDocumentTypeChoices.ShareholderDeclaration]:
				"Aandeelhoudersverklaring",
			[RiskKycVerificationDocumentDocumentTypeChoices.SocialSecurityNumber]:
				"Burgerservicenummer (BSN)",
			[RiskKycVerificationDocumentDocumentTypeChoices.TaxIdNumber]:
				"BTW-nummer",
			[RiskKycVerificationDocumentDocumentTypeChoices.UboDeclaration]:
				"UBO-verklaring",
			[RiskKycVerificationDocumentDocumentTypeChoices.UtilityBill]:
				"Energierekening",
			[RiskKycVerificationDocumentDocumentTypeChoices.Visa]: "Visum",
		}
		return typeMap[documentType] || documentType
	}

	return (
		<div className="mt-4">
			<Table className="min-w-[32rem] lg:min-w-0">
				<TableHead>
					<TableRowCell>
						<TableHeading>
							{t(
								"investor:identity.documents.table.header.document_type",
							)}
						</TableHeading>
						<TableHeading>
							{t(
								"investor:identity.documents.table.header.expiry_date",
							)}
						</TableHeading>
					</TableRowCell>
				</TableHead>
				<TableBody>
					{documents.map((document, index) => (
						<TableRowCell key={document.id} isOdd={index % 2 === 0}>
							<TableDataCell>
								{getDocumentTypeDisplayName(
									document.document_type,
								)}
							</TableDataCell>
							<TableDataCell>
								{document.expiry_date
									? DateTime.fromISO(
											document.expiry_date,
										).toFormat("dd-MM-yyyy")
									: "-"}
							</TableDataCell>
						</TableRowCell>
					))}
				</TableBody>
			</Table>
		</div>
	)
}
